import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { BaseListenable1u3g4s45l82o6 as BaseListenable } from '../../../../../../reactive/com/lightningkite/reactive/core/abstracts.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get_selectionStart2vknrfox4u4l8 as get_selectionStart,
  get_selectionEnd2du62zn9takrg as get_selectionEnd,
  setSelectionRange10xzbpb686fcx as setSelectionRange,
} from './FormattedTextInput.commonHtml.js.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Char19o2r8palgjof as Char } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { substringiqarkczpya5m as substring } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import {
  valueSet3cf2hvvu95f3 as valueSet,
  set3ct43wkzm94lj as set,
  lens2e2i845xidu26 as lens,
  lens26es9640ifscs as lens_0,
  get_state389x218zizu8a as get_state,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
} from '../../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { NativeElementWithAction32yo3q41a36ui as NativeElementWithAction } from '../InteractiveElement.mjs';
import { KeyCodes_instance1xpu3tad1ataj as KeyCodes_instance } from '../../models/KeyCode.commonHtml.mjs';
import { KeyboardHints3coyq4x1rsbe3 as KeyboardHints } from '../../models/data.mjs';
import {
  formattedTextInputDriverValue2ukph3tibkiba as formattedTextInputDriverValue,
  formattedTextInputDriverActions9fmp7i5lw2lt as formattedTextInputDriverActions,
} from './DriverOverrides.mjs';
import { plus2m1vv33moko5t as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { applyKeyboardHints2y8fo0b5cldu1 as applyKeyboardHints } from './KeyboardHints.ext.mjs';
import { get_theme90wn9glxu60a as get_theme } from '../Element.ext.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function applyAlign($this, value) {
  var tmp0 = $this.native_1.style_1;
  var tmp;
  switch (value.ordinal_1) {
    case 0:
      tmp = 'start';
      break;
    case 1:
      tmp = 'center';
      break;
    case 2:
      tmp = 'end';
      break;
    case 3:
      tmp = 'justify';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  // Inline function 'com.lightningkite.kiteui.views.textAlign' call
  var value_0 = tmp;
  tmp0.native_1.textAlign = value_0;
}
function FormattedTextInput$formatter$lambda(it) {
  return it;
}
function FormattedTextInput$isRawData$lambda(it) {
  return true;
}
var FormattedTextInput$content$1Class;
function FormattedTextInput$content$1() {
  if (FormattedTextInput$content$1Class === VOID) {
    class $ extends BaseListenable() {
      constructor(this$0) {
        return new.target.new_com_lightningkite_kiteui_views_direct_FormattedTextInput__no_name_provided__yq1957_k$(this$0);
      }
      static new_com_lightningkite_kiteui_views_direct_FormattedTextInput__no_name_provided__yq1957_k$(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.this$0__1 = this$0;
        var $this = this.new_com_lightningkite_reactive_core_BaseListenable_e3suws_k$($box);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this$0.native_1;
        var tmp0_safe_receiver = this_0.element_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener('input', (it) => {
            // Inline function 'com.lightningkite.kiteui.views.valueString' call
            var tmp = this$0.native_1.attributes_1.native_1.value;
            var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
            var tmp0 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
            var tmp2 = get_selectionStart(this$0);
            var tmp4 = get_selectionEnd(this$0);
            var tmp6 = this$0.isRawData_1;
            // Inline function 'com.lightningkite.kiteui.utils.repairFormatAndPosition' call
            var formatter = this$0.formatter_1;
            // Inline function 'kotlin.text.filter' call
            // Inline function 'kotlin.text.filterTo' call
            var destination = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
            var inductionVariable = 0;
            var last = charSequenceLength(tmp0);
            if (inductionVariable < last)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var element = charSequenceGet(tmp0, index);
                if (tmp6(new (Char())(element))) {
                  destination.append_58al37_k$(element);
                }
              }
               while (inductionVariable < last);
            var clean = destination.toString();
            var result = formatter(clean);
            var tmp_0;
            if (tmp2 == null) {
              tmp_0 = null;
            } else {
              // Inline function 'kotlin.text.count' call
              var count = 0;
              var indexedObject = substring(tmp0, 0, tmp2);
              var inductionVariable_0 = 0;
              while (inductionVariable_0 < charSequenceLength(indexedObject)) {
                var element_0 = charSequenceGet(indexedObject, inductionVariable_0);
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                if (!tmp6(new (Char())(element_0))) {
                  count = count + 1 | 0;
                }
              }
              tmp_0 = tmp2 - count | 0;
            }
            var startPosOnClean = tmp_0;
            var tmp_1;
            if (tmp4 == null) {
              tmp_1 = null;
            } else {
              // Inline function 'kotlin.text.count' call
              var count_0 = 0;
              var indexedObject_0 = substring(tmp0, 0, tmp4);
              var inductionVariable_1 = 0;
              while (inductionVariable_1 < charSequenceLength(indexedObject_0)) {
                var element_1 = charSequenceGet(indexedObject_0, inductionVariable_1);
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                if (!tmp6(new (Char())(element_1))) {
                  count_0 = count_0 + 1 | 0;
                }
              }
              tmp_1 = tmp4 - count_0 | 0;
            }
            var endPosOnClean = tmp_1;
            var tmp_2;
            if (startPosOnClean == null) {
              tmp_2 = null;
            } else {
              // Inline function 'kotlin.let' call
              var remaining = startPosOnClean;
              var count_1 = 0;
              $l$loop: while (remaining > 0 && count_1 < result.length) {
                var _unary__edvuaz = count_1;
                count_1 = _unary__edvuaz + 1 | 0;
                if (tmp6(new (Char())(charCodeAt(result, _unary__edvuaz))))
                  remaining = remaining - 1 | 0;
              }
              tmp_2 = count_1;
            }
            var startPosOnResult = tmp_2;
            var tmp_3;
            if (endPosOnClean == null) {
              tmp_3 = null;
            } else {
              // Inline function 'kotlin.let' call
              var remaining_0 = endPosOnClean;
              var count_2 = 0;
              $l$loop_0: while (remaining_0 > 0 && count_2 < result.length) {
                var _unary__edvuaz_0 = count_2;
                count_2 = _unary__edvuaz_0 + 1 | 0;
                if (tmp6(new (Char())(charCodeAt(result, _unary__edvuaz_0))))
                  remaining_0 = remaining_0 - 1 | 0;
              }
              tmp_3 = count_2;
            }
            var endPosOnResult = tmp_3;
            // Inline function 'com.lightningkite.kiteui.views.valueString' call
            this$0.native_1.attributes_1.native_1.value = result;
            if (!(startPosOnResult == null) && !(endPosOnResult == null)) {
              setSelectionRange(this$0, startPosOnResult, endPosOnResult);
            }
            $this.invokeAllListeners_uusj2y_k$();
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this_0.eventsBack_1['on' + 'input'];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + 'input';
          this_0.eventsBack_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            // Inline function 'com.lightningkite.kiteui.views.valueString' call
            var tmp = this$0.native_1.attributes_1.native_1.value;
            var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
            var tmp0 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
            var tmp2 = get_selectionStart(this$0);
            var tmp4 = get_selectionEnd(this$0);
            var tmp6 = this$0.isRawData_1;
            // Inline function 'com.lightningkite.kiteui.utils.repairFormatAndPosition' call
            var formatter = this$0.formatter_1;
            // Inline function 'kotlin.text.filter' call
            // Inline function 'kotlin.text.filterTo' call
            var destination = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
            var inductionVariable = 0;
            var last = charSequenceLength(tmp0);
            if (inductionVariable < last)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var element = charSequenceGet(tmp0, index);
                if (tmp6(new (Char())(element))) {
                  destination.append_58al37_k$(element);
                }
              }
               while (inductionVariable < last);
            var clean = destination.toString();
            var result = formatter(clean);
            var tmp_0;
            if (tmp2 == null) {
              tmp_0 = null;
            } else {
              // Inline function 'kotlin.text.count' call
              var count = 0;
              var indexedObject = substring(tmp0, 0, tmp2);
              var inductionVariable_0 = 0;
              while (inductionVariable_0 < charSequenceLength(indexedObject)) {
                var element_0 = charSequenceGet(indexedObject, inductionVariable_0);
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                if (!tmp6(new (Char())(element_0))) {
                  count = count + 1 | 0;
                }
              }
              tmp_0 = tmp2 - count | 0;
            }
            var startPosOnClean = tmp_0;
            var tmp_1;
            if (tmp4 == null) {
              tmp_1 = null;
            } else {
              // Inline function 'kotlin.text.count' call
              var count_0 = 0;
              var indexedObject_0 = substring(tmp0, 0, tmp4);
              var inductionVariable_1 = 0;
              while (inductionVariable_1 < charSequenceLength(indexedObject_0)) {
                var element_1 = charSequenceGet(indexedObject_0, inductionVariable_1);
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                if (!tmp6(new (Char())(element_1))) {
                  count_0 = count_0 + 1 | 0;
                }
              }
              tmp_1 = tmp4 - count_0 | 0;
            }
            var endPosOnClean = tmp_1;
            var tmp_2;
            if (startPosOnClean == null) {
              tmp_2 = null;
            } else {
              // Inline function 'kotlin.let' call
              var remaining = startPosOnClean;
              var count_1 = 0;
              $l$loop_1: while (remaining > 0 && count_1 < result.length) {
                var _unary__edvuaz = count_1;
                count_1 = _unary__edvuaz + 1 | 0;
                if (tmp6(new (Char())(charCodeAt(result, _unary__edvuaz))))
                  remaining = remaining - 1 | 0;
              }
              tmp_2 = count_1;
            }
            var startPosOnResult = tmp_2;
            var tmp_3;
            if (endPosOnClean == null) {
              tmp_3 = null;
            } else {
              // Inline function 'kotlin.let' call
              var remaining_0 = endPosOnClean;
              var count_2 = 0;
              $l$loop_2: while (remaining_0 > 0 && count_2 < result.length) {
                var _unary__edvuaz_0 = count_2;
                count_2 = _unary__edvuaz_0 + 1 | 0;
                if (tmp6(new (Char())(charCodeAt(result, _unary__edvuaz_0))))
                  remaining_0 = remaining_0 - 1 | 0;
              }
              tmp_3 = count_2;
            }
            var endPosOnResult = tmp_3;
            // Inline function 'com.lightningkite.kiteui.views.valueString' call
            this$0.native_1.attributes_1.native_1.value = result;
            if (!(startPosOnResult == null) && !(endPosOnResult == null)) {
              setSelectionRange(this$0, startPosOnResult, endPosOnResult);
            }
            $this.invokeAllListeners_uusj2y_k$();
            return Unit_instance;
          };
        }
        return $this;
      }
      set_value_hd9162_k$(value) {
        // Inline function 'kotlin.text.filter' call
        var predicate = this.this$0__1.isRawData_1;
        // Inline function 'kotlin.text.filterTo' call
        var destination = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        var inductionVariable = 0;
        var last = charSequenceLength(value);
        if (inductionVariable < last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var element = charSequenceGet(value, index);
            if (predicate(new (Char())(element))) {
              destination.append_58al37_k$(element);
            }
          }
           while (inductionVariable < last);
        var clean = destination.toString();
        var formatted = this.this$0__1.formatter_1(clean);
        // Inline function 'com.lightningkite.kiteui.views.valueString' call
        var tmp = this.this$0__1.native_1.attributes_1.native_1.value;
        if (!(((!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null) === formatted)) {
          // Inline function 'com.lightningkite.kiteui.views.valueString' call
          this.this$0__1.native_1.attributes_1.native_1.value = formatted;
          this.invokeAllListeners_uusj2y_k$();
        }
      }
      set_value_v1vabv_k$(_set____db54di) {
        return this.set_value_hd9162_k$((!(_set____db54di == null) ? typeof _set____db54di === 'string' : false) ? _set____db54di : THROW_CCE());
      }
      get_value_j01efc_k$() {
        // Inline function 'com.lightningkite.kiteui.views.valueString' call
        var tmp = this.this$0__1.native_1.attributes_1.native_1.value;
        var tmp0_safe_receiver = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.text.filter' call
          var predicate = this.this$0__1.isRawData_1;
          // Inline function 'kotlin.text.filterTo' call
          var destination = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
          var inductionVariable = 0;
          var last = charSequenceLength(tmp0_safe_receiver);
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var element = charSequenceGet(tmp0_safe_receiver, index);
              if (predicate(new (Char())(element))) {
                destination.append_58al37_k$(element);
              }
            }
             while (inductionVariable < last);
          tmp_0 = destination.toString();
        }
        var tmp1_elvis_lhs = tmp_0;
        return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
      }
    }
    protoOf($).valueSet_aujvv6_k$ = valueSet;
    protoOf($).set_revjhg_k$ = set;
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    protoOf($).get_state_wc71uu_k$ = get_state;
    initMetadataForClass($, VOID, VOID, VOID, [MutableReactiveValue()], [1]);
    FormattedTextInput$content$1Class = $;
  }
  return FormattedTextInput$content$1Class;
}
var FormattedTextInputClass;
function FormattedTextInput() {
  if (FormattedTextInputClass === VOID) {
    class $ extends NativeElementWithAction() {
      constructor(context) {
        super(context);
        this.native_1.tag_1 = 'input';
        this.native_1.classes_1.add_utx5q5_k$('editable');
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this.native_1;
        var tmp0_safe_receiver = this_0.element_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener('keyup', (it) => {
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.get_enter_iqxcq7_k$()) {
              var tmp0_safe_receiver = this.action_1;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.startAction_u0zgbm_k$(this);
              }
            }
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this_0.eventsBack_1['on' + 'keyup'];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + 'keyup';
          this_0.eventsBack_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.get_enter_iqxcq7_k$()) {
              var tmp0_safe_receiver_0 = this.action_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                tmp0_safe_receiver_0.startAction_u0zgbm_k$(this);
              }
            }
            return Unit_instance;
          };
        }
        var tmp_2 = this;
        tmp_2.formatter_1 = FormattedTextInput$formatter$lambda;
        var tmp_3 = this;
        tmp_3.isRawData_1 = FormattedTextInput$isRawData$lambda;
        var tmp_4 = this;
        tmp_4.content_1 = FormattedTextInput$content$1().new_com_lightningkite_kiteui_views_direct_FormattedTextInput__no_name_provided__yq1957_k$(this);
        this.keyboardHints_1 = new (KeyboardHints())();
        this._align_1 = null;
      }
      get_driverValue_yh5neo_k$() {
        return formattedTextInputDriverValue(this);
      }
      get_driverActions_8jqr2k_k$() {
        return plus(super.get_driverActions_8jqr2k_k$(), formattedTextInputDriverActions(this));
      }
      format_eymgoy_k$(isRawData, formatter) {
        this.formatter_1 = formatter;
        this.isRawData_1 = isRawData;
      }
      set_keyboardHints_w6k1he_k$(value) {
        this.keyboardHints_1 = value;
        applyKeyboardHints(this.native_1, value);
      }
      set_align_ypalx0_k$(value) {
        this._align_1 = value;
        applyAlign(this, value == null ? get_theme(this).font_1.align_1 : value);
      }
      get_align_iooo9o_k$() {
        return this._align_1;
      }
      nativeApplyTheme_6heplg_k$(theme) {
        super.nativeApplyTheme_6heplg_k$(theme);
        var tmp0_elvis_lhs = this._align_1;
        applyAlign(this, tmp0_elvis_lhs == null ? theme.theme_1.font_1.align_1 : tmp0_elvis_lhs);
      }
    }
    initMetadataForClass($, 'FormattedTextInput');
    FormattedTextInputClass = $;
  }
  return FormattedTextInputClass;
}
function FormattedTextInput$_get_content_$ref_pok0f8(p0) {
  return constructCallableReference(() => p0.content_1, 0, 0, 83, VOID, [p0]);
}
function FormattedTextInput$_get_hint_$ref_iu6w22(p0) {
  return constructCallableReference(() => {
    // Inline function 'com.lightningkite.kiteui.views.direct.FormattedTextInput.hint' call
    // Inline function 'com.lightningkite.kiteui.views.placeholder' call
    var tmp = p0.native_1.attributes_1.native_1.placeholder;
    var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  }, 0, 0, 84, VOID, [p0]);
}
function FormattedTextInput$_set_hint_$ref_61akla(p0) {
  return constructCallableReference((p0_0) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.FormattedTextInput.hint' call
    // Inline function 'com.lightningkite.kiteui.views.placeholder' call
    p0.native_1.attributes_1.native_1.placeholder = p0_0;
    return Unit_instance;
  }, 1, 0, 85, VOID, [p0]);
}
function FormattedTextInput$_get_align_$ref_vo3rx4(p0) {
  return constructCallableReference(() => p0.get_align_iooo9o_k$(), 0, 0, 86, VOID, [p0]);
}
function FormattedTextInput$_set_align_$ref_2d9bik(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_align_ypalx0_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 87, VOID, [p0]);
}
//region block: exports
export {
  FormattedTextInput as FormattedTextInput3hltc3nesrzjq,
  FormattedTextInput$_get_align_$ref_vo3rx4 as FormattedTextInput$_get_align_$ref_vo3rx42n1o02e9pl5u3,
  FormattedTextInput$_set_align_$ref_2d9bik as FormattedTextInput$_set_align_$ref_2d9bik2ytvu11xvgwtq,
  FormattedTextInput$_get_content_$ref_pok0f8 as FormattedTextInput$_get_content_$ref_pok0f82dt5dx9gm3qog,
  FormattedTextInput$_get_hint_$ref_iu6w22 as FormattedTextInput$_get_hint_$ref_iu6w222csieh0dinqk,
  FormattedTextInput$_set_hint_$ref_61akla as FormattedTextInput$_set_hint_$ref_61akla19heaeuxat3bz,
};
//endregion

//# sourceMappingURL=FormattedTextInput.commonHtml.mjs.map
